import * as Sentry from '@sentry/vue';

// TODO: maybe check if we want to do data processing
export const logSentry = Sentry.captureMessage;
